import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65f799ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "word" }

import AppLink from '@/components/AppLink.vue';
  import { useRoute } from 'vue-router';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ShareList',
  setup(__props) {

  const route = useRoute();
  
return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(" 新建菜单完成后，请到 "),
    _createVNode(_component_a_button, {
      type: "link",
      class: "mod_btn_link"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: { path: `/market/${_unref(route).params.studioId}/sharing_set` },
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 营销互动 ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }),
    _createTextVNode(" 设置分享。 ")
  ]))
}
}

})